declare global {
  interface Window {
    dataLayer?: Record<string, unknown>[];
    clarity?: (...args: unknown[]) => void;
    mixpanel?: {
      track: (event: string, properties?: Record<string, unknown>) => void;
      identify: (id: string) => void;
      people: { set: (properties: Record<string, unknown>) => void };
    };
  }
}

export function trackEvent(eventName: string, params?: Record<string, unknown>) {
  window.dataLayer?.push({ event: eventName, ...params });
  window.mixpanel?.track(eventName, params);
}

export function identifyDataLayerUser(id: number): void {
  const userId = String(id);
  const dataLayer = window.dataLayer ?? (window.dataLayer = []);
  if (latestDataLayerUserId(dataLayer) === userId) return;

  dataLayer.push({ user_id: userId });
}

export function clearDataLayerUser(): void {
  const dataLayer = window.dataLayer ?? (window.dataLayer = []);
  dataLayer.push({ user_id: undefined });
}

export function tagClaritySession(key: string, value: string) {
  if (typeof window.clarity === 'function') {
    window.clarity('set', key, value);
  }
}

export function identifyUser(id: number, email: string, name: string | null) {
  identifyDataLayerUser(id);
  window.mixpanel?.identify(String(id));
  window.mixpanel?.people.set({ $email: email, $name: name });
}

function latestDataLayerUserId(dataLayer: Record<string, unknown>[]): unknown {
  return dataLayer.findLast((entry) => Object.hasOwn(entry, 'user_id'))?.user_id;
}

export function markFunnelStage(stage: string, event: string, payload?: Record<string, unknown>) {
  trackEvent(event, payload);
  tagClaritySession('funnel_stage', stage);
}
